import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "./api";
import "./SignupPage.css";
import { Select } from "@mui/material";
import { Form, Input, Button, message } from "antd";
import api from './api'

function SignupPage() {

  const generateId = () => Array.from({ length: 10 }, () => {
    return "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(Math.random() * 36)];
  }).join("")



  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("vendor");
  const [vendorId, setVendorId] = useState(generateId());
  const [vendorName, setVendorName] = useState("");
  const [vendorAddress, setVendorAddress] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setmobile] = useState("");
  const [phone, setphone] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');




  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isGstUnique, setIsGstUnique] = useState(false);
  const [isUsernameUnique, setIsUsernameUnique] = useState(false);

  const openPopup = async (e) => {
    e.preventDefault();

    const usernameData = await api.post("/checkUsername", { username })
    if (usernameData.data.isUsernameUnique) {
      setIsUsernameUnique(true);
    } else {
      setIsUsernameUnique(false)
    }

    const gstData = await api.post("/checkGst", { gstIn })
    if (gstData.data.isGstUnique) {
      setIsGstUnique(true);
    } else {
      setIsGstUnique(false);
    }



    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setIsLoading(false);
  };






  useEffect(() => {
    fetch('https://raw.githubusercontent.com/nshntarora/Indian-Cities-JSON/master/cities.json')
      .then(response => response.json())
      .then(data => {
        const stateCityMap = {};


        data.forEach(city => {
          if (stateCityMap[city.state]) {
            stateCityMap[city.state].push({ name: city.name, code: city.id });
          } else {
            stateCityMap[city.state] = [{ name: city.name, code: city.id }];
          }
        });

        const statesArray = Object.keys(stateCityMap).map((stateName, index) => ({
          name: stateName,
          code: index.toString().padStart(2, '0'),
          cities: stateCityMap[stateName],
        }));

        setStates(statesArray);

      })
      .catch(error => console.error('Error fetching city data:', error));
  }, []);

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
    const state = states.find(s => s.name === selectedState);
    setCities(state ? state.cities : []);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
  };


  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Example of handling login response
  const handleSignup = async (e) => {
    e.preventDefault();

    if (!isGstUnique || !isUsernameUnique) {
      return;
    }

    setIsLoading(true); // Set loading state to true while making the request
    setError(null); // Reset error message if any


    try {
      const requestData = {
  email,
  mobile,
  phone,
  vendorId,
  vendorName,
  vendorAddress,
  state: selectedState,
  city: selectedCity,
  gstIn,
  paymentModes: {
    cod: true,
    online: false
  }
}


      if (!username || !password || !role || !email || !mobile || !selectedCity || !vendorId || !vendorName || !vendorAddress || !selectedState) {
        message.error("Please fill all mandatory fields (username, password, email, mobile, name, address, state, city)")
        return;
      }

      const vendorManagementResponse = await api.post("/addVendor", requestData);

      const data = vendorManagementResponse?.data?.vendor;


      if (!data?._id) {
        message.error("Distributor Creation Failed.")
        return;
      }

      message.success("Distributor details added successfully!");

      const requestUserData = {
        username,
        password,
        role,
        vendorId: data?._id
      }

      const userResponse = await api.post("/addUser", requestUserData);

      if (userResponse.status === 201) {
        message.success("User details added successfully!");
        navigate('/login')
      } else {
        console.error("Enter unique username")
        return;
      }

    } catch (error) {
      setVendorId(generateId())
      console.error("Error:", error.response?.data || error.message);
      message.error(error?.response?.data?.error);
      setIsLoading(false);
    }
  };


  return (
    <div className="signup-container">
      <div className="signup-card">
        <h2 className="signup-heading">Welcome Back!</h2>
        <p className="signup-subheading">Please sign up to your account</p>
        <form onSubmit={(e) => openPopup(e)}>
          <div className="signup-form">
            <div className="form-field">
              <label htmlFor="username" className="form-label">
                Username<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter your username"
                className="form-input"
                aria-label="Username"
                maxlength="25"
              />
            </div>
            <div className="form-field">
              <label htmlFor="password" className="form-label">
                Password<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                className="form-input"
                aria-label="Password"
                maxlength="25"
              />
            </div>
            <div className="form-field">
              <label htmlFor="vendorName" className="form-label">
                Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="vendorName"
                value={vendorName}
                onChange={(e) => setVendorName(e.target.value)}
                required
                placeholder="Enter Distributor's Name"
                className="form-input"
                aria-label="vendorName"
                maxlength="25"
              />
            </div>
            <div className="form-field">
              <label htmlFor="vendorAddress" className="form-label">
                Address<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="vendorAddress"
                value={vendorAddress}
                onChange={(e) => setVendorAddress(e.target.value)}
                required
                placeholder="Enter Distributor's Address"
                className="form-input"
                aria-label="vendorAddress"
                maxlength="150"
              />
            </div>
            <div className="form-field">
              <label htmlFor="state" className="form-label">
                State<span style={{ color: "red" }}>*</span>
              </label>

              <select className="form-input" name="state" id="state" onChange={(e) => handleStateChange(e)} value={selectedState}>
                {!selectedState && (<option>
                  select state
                </option>)}
                {states.map((state) => (
                  <option key={state.code} value={state.name}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-field">
  <label htmlFor="city" className="form-label">
    City<span style={{ color: "red" }}>*</span>
  </label>

  <input
    type="text"
    className="form-input"
    id="city"
    name="city"
    placeholder="Enter city"
    value={selectedCity}
    onChange={(e) => setSelectedCity(e.target.value)}
  />
</div>

            <div className="form-field">
              <label htmlFor="email" className="form-label">
                Email ID <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter Email ID"
                className="form-input"
                aria-label="email"
                maxlength="35"
              />
            </div>
            <div className="form-field">
              <label htmlFor="mobile" className="form-label">
                Mobile Number (+91) <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="tel"
                id="mobile"
                value={mobile}
                onChange={(e) => setmobile(e.target.value)}
                required
                placeholder="Enter Phone number"
                className="form-input"
                aria-label="mobile"
                maxlength="10"
                pattern="[0-9]{10}"
              />
            </div>

            <div className="form-field">
              <label htmlFor="gstIn" className="form-label">
                GSTIN/UIN
              </label>
              <input
                type="text"
                id="gstIn"
                value={gstIn}
                onChange={(e) => setGstIn(e.target.value.toUpperCase())}
                placeholder="Enter Distributor's GSTIN"
                className="form-input"
                aria-label="gstIn"
                maxlength="15"
                minlength="15"
              />
            </div>

            <div className="form-field">
              <label htmlFor="phone" className="form-label">
                Contact Number
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setphone(e.target.value)}
                placeholder="Enter telephone number"
                className="form-input"
                aria-label="phone"
                maxlength="10"
                pattern="[0-9]{10}"
              />
            </div>
          </div>


          <div className="aligin-center">
            {error && <p className="error-message">{error}</p>}
            <button type="submit" onClick={openPopup} className="signup-button" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign Up"}
            </button>
            <p class="text-xs text-muted-foreground">Already have an account? <span onClick={() => navigate("/login")} class="sign-up">Login</span>
            </p>
          </div>

        </form>




        <div>
          {isPopupOpen && (
            <div className="popup">
              <div className="popup-content">
                <h2>Verify Details</h2>
                <p>If all details are filled correctly then click on "Confirm" Button.</p>
                {!isUsernameUnique && <li style={{ color: "red" }}>Username already taken. Create new username.</li>}
                {!isGstUnique && <li style={{ color: "red" }}>GST already used. Use another one or leave it blank.</li>}
                <div style={{ display: "flex", flexDirection: "row", gap: "55%", paddingLeft: "30px", paddingRight: "30px", paddingTop: "10px" }}>
                  <Button style={{ backgroundColor: "#34a8eb", color: "white" }} onClick={closePopup}>Edit</Button>
                  <Button style={{ backgroundColor: "#5ceb34", color: "white" }} onClick={handleSignup}>Confirm</Button>
                </div>
              </div>
            </div>
          )}
        </div>


      </div>
    </div>
  );
  
}

export default SignupPage;
